import {
    Component,
    forwardRef,
    Input,
    OnInit
} from '@angular/core';

import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR
} from '@angular/forms';

import { IntegrationService } from '../integration.service';

@Component({
    selector: 'app-slack-channel-select',
    templateUrl: './slack-channel-select.component.html',
    styleUrls: ['./slack-channel-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlackChannelSelectComponent),
            multi: true
        }
    ],
})
export class SlackChannelSelectComponent implements ControlValueAccessor, OnInit {
    channels: Array<any> = [];
    @Input() integrationId: string;
    onChange;
    onTouched;
    selectedChannel: string;

    constructor (
        public integrationService: IntegrationService,
    ) {
    }

    ngOnInit (): void {
        if (!this.integrationId) {
            return;
        }
        this.integrationService.getSlackChannels(this.integrationId).then((result) => {
            this.channels = result.channels;
        }).catch((err) => {
            console.error(err);
        });
    }

    registerOnChange (fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched (fn: any): void {
        this.onTouched = fn;
    }

    writeValue (val: any): void {
        if (
            (this.onChange && this.onTouched)
        ) {
            this.selectedChannel = val;
        }
    }
}
